"use strict";

define('libs/format/status',['underscore', 'handlebars', '../color', './empty'], function (_, Handlebars, Color, emptyFormatter) {
  var statusFormatter = function statusFormatter(emptyText) {
    var empty = emptyFormatter(emptyText);
    return function (value) {
      if (!value) {
        return empty(value);
      }
      return new Handlebars.SafeString(['<span class="ui ' + Color.Status(value) + ' empty circular label"></span>&nbsp;&nbsp;', Handlebars.escapeExpression(value)].join(''));
    };
  };
  return statusFormatter;
});

